module.exports = __webpack_public_path__ + "Journal Regular.fff50764b41a65efccdd.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/fonts/Journal Regular.svg
// module id = ../../../../../src/fonts/Journal Regular.svg
// module chunks = styles